import { get, post } from '@/api/request'

export default {

  store: (note, success, failure) => post(
    '/api/note',
    note,
    response => success(response),
    error => failure(error)
  ),

  update: (note, success, failure) => post(
    `/api/note/${note.id}`,
    note,
    response => success(response),
    error => failure(error)
  ),

  loadActiveNote: (success, failure) => get(
    `/api/active-note`,
    response => success(response),
    error => failure(error)
  ),

  pinNote: (noteId, success, failure) => post(
    `/api/note/${noteId}/pin`,
    {},
    response => success(response),
    error => failure(error)
  ),

  trashNote: (noteId, success, failure) => post(
    `/api/note/${noteId}/trash`,
    {},
    response => success(response),
    error => failure(error)
  )
}